import React from 'react';

import { Content } from '../../components/layout/Content';

export const Blank = () => <Content />;
